export default "__VITE_ASSET__V8_3M6RA__"